import React, { useState, useEffect } from "react";
import CityServices from "services/CityServices";
import Select from "react-select";

const SelectSingleCityOnly = ({
  register,
  selectedCity,
  handleCityChange,
  handleCityChangeName,
  name,
  label,
  readonly,
}) => {
  const [cities, setSingleCity] = useState([]);
  const customSelectStyles = {
    control: (base, state) => ({
      ...base,
      border: "1px",
      boxShadow: "none",
      backgroundColor: state.isDisabled ? "#E2E8F0" : "#FFFFFF",
      cursor: state.isDisabled ? "not-allowed" : "default",
    }),
    option: (provided, state) => ({
      ...provided,
      background: state.isSelected
        ? "#0e9f6e"
        : state.isFocused
        ? "rgba(0, 0, 0, 0.15)"
        : "white",
      color: state.isSelected ? "white" : state.onClick ? "green" : "black",
      "&:hover": {
        background: "rgba(0, 0, 0, 0.15)",
        color: "black",
      },
    }),
    menu: (provided) => ({
      ...provided,
      margin: "10px 0 -10px 0",
      zIndex: "55555",
      overflow: "hidden",
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: "150px",
      overflowY: "scroll",
      scrollbarWidth: "thin",
      scrollbarColor: "#888 #f1f1f1",
      "&::-webkit-scrollbar": {
        width: "6px",
      },
      "&::-webkit-scrollbar-thumb": {
        background: "#888",
        borderRadius: "3px",
      },
      "&::-webkit-scrollbar-thumb:hover": {
        background: "#555",
      },
    }),
    indicatorSeparator: () => ({
      display: "none", // Removes the separator line
    }),
     singleValue: (provided) => ({
    ...provided,
    color: "inherit", // or remove this line entirely if you want to use inherited/default styling
  })
  };

  useEffect(() => {
    let isMounted = true; // Add this variable to track the component's mounting state

    async function fetchCity() {
      try {
        const response = await CityServices.getAllCity();
        const transformedData = response.data.map((item) => ({
          value: String(item.id_city),
          label: item.name,
        }));

        // Check if the component is still mounted before updating the state
        if (isMounted) {
          setSingleCity(transformedData);
        }
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    }

    fetchCity();

    // Cleanup function to set isMounted to false when the component is unmounted
    return () => {
      isMounted = false;
    };
  }, []);
  useEffect(() => {
  // This runs whenever the cities list or selectedCity changes
  if (cities.length && selectedCity) {
    const selectedItem = cities.find(
      (c) => c.value === String(selectedCity) // match ID
    );
    if (selectedItem && handleCityChangeName) {
      handleCityChangeName(selectedItem.label); // update form with label
    }
  }
}, [cities, selectedCity]);


  const handleCitySelect = async (selected) => {
    const item = cities.find((item) => item.value === selected.value);
    if (item) {
      if (handleCityChange) {
        handleCityChange(selected.value);
        // console.log(selected.value)
      }

      if (handleCityChangeName) {
        handleCityChangeName(selected.label);
      }
    }
  };
  return (
    <Select
      className="dark:text-white-300 leading-5 rounded-md focus:border-white-200 border-gray-200 dark:border-gray-600 focus:ring focus:ring-green-300 dark:focus:border-gray-500 dark:focus:ring-gray-300 dark:bg-gray-700 border h-10 text-sm focus:outline-none block w-full bg-white-100 border-transparent focus:bg-white"
      // isSearchable={false}
      {...register(`${name}`, {
        required: !selectedCity ? `${label} is required!` : false,
      })}
      // defaultValue={selectedCity}
      name={name}
      isDisabled={readonly}
      styles={customSelectStyles}
      options={cities}
      onChange={(e) => handleCitySelect(e)}
      value={
        selectedCity
          ? cities.find(
              (option) =>
                option.value === String(selectedCity) ||
                option.label === selectedCity
            )
          : null
      }
    />
  );
};

export default SelectSingleCityOnly;